import i18n from '@/common/i18n';
import {
  ACTIVE_CLUSTER_STATUSES,
  CLUSTER_STATUSES,
} from '@/common/constants/computeCluster.constants';
import useTasksStore from '@/common/store/pinia/tasks';
import state from './compute.state';
import mutations from './compute.mutations';
import actions from './compute.actions';

const STATUSES_TYPES = {
  absent: 'default',
  active: 'success',
  healthy: 'success',
  critical: 'danger',
  warning: 'warning',
  changing: 'success',
  reconfiguring: 'success',
  deploying: 'default',
  destroying: 'default',
  error: 'danger'
};

const computeModule = {
  state,
  mutations,
  actions,
  getters: {
    computeClusterStatusText: (_state) => {
      const STATUSES_TEXT = {
        [CLUSTER_STATUSES.NOT_INSTALLED]: i18n.t('Absent'),
        [CLUSTER_STATUSES.INSTALLED]: i18n.t('Healthy'),
        [CLUSTER_STATUSES.ACTIVE]: i18n.t('Healthy'),
        [CLUSTER_STATUSES.CRITICAL]: i18n.t('Critical'),
        [CLUSTER_STATUSES.WARNING]: i18n.t('Warning'),
        [CLUSTER_STATUSES.CONFIGURING]: i18n.t('Configuring'),
        [CLUSTER_STATUSES.DEPLOYING]: i18n.t('Deploying'),
        [CLUSTER_STATUSES.DESTROYING]: i18n.t('Destroying'),
        [CLUSTER_STATUSES.ERROR]: i18n.t('Error')
      };

      return STATUSES_TEXT[_state.computeClusterDetails.status];
    },
    clusterStatusType: _state => STATUSES_TYPES[_state.computeClusterDetails.status],
    isComputeConfigured: _state => ACTIVE_CLUSTER_STATUSES.indexOf(_state.computeClusterDetails.status) > -1,
    isComputeConfiguring: _state => CLUSTER_STATUSES.CONFIGURING === _state.computeClusterDetails.status,
    osTypes: (_state) => {
      // eslint-disable-next-line camelcase
      const osDistributions = _state.computeClusterDetails?.capabilities?.os_distributions || [];

      return osDistributions.map(obj => ({
        name: obj.id,
        label: obj.title,
        osType: obj.os_type
      }));
    },
    kubernetesVersions: (_state) => {
      // eslint-disable-next-line camelcase
      const versions = _state.computeClusterDetails?.capabilities?.k8saas_versions || [];

      return versions.map(obj => ({ value: obj, label: obj }));
    },
    // eslint-disable-next-line camelcase
    kubernetesCapabilities: (_state) => _state.computeClusterDetails.capabilities?.k8saas_capabilities,
    // eslint-disable-next-line camelcase
    computeClusterTaskId: _state => _state.computeClusterDetails?.task_id,
    // eslint-disable-next-line camelcase
    computeClusterTask: (_state, getters) => {
      const tasksStore = useTasksStore();
      return getters.computeClusterTaskId && tasksStore.getItemById(getters.computeClusterTaskId);
    },
    computeClusterFeatures: (_state) => _state.computeClusterDetails?.features
        ? Object.fromEntries(_state.computeClusterDetails.features.map(key => [key, true]))
        : {},
    computeNodesCount: _state => Object.keys(_state.computeClusterDetails?.capabilities?.compute_nodes || {}).length,
    computeConsolidationTags: _state => _state.computeClusterDetails?.options?.scheduler?.servers_consolidation_tags || [],
    quotas: _state => _state.quotas,
    // vinfra service compute set [--endpoint-hostname <hostname>]
    hostname: _state => _state.computeClusterDetails?.options?.endpoint_hostname,
    selfservicePanelPort: () => 8800,
    macPrefix: _state => _state.computeClusterDetails?.options?.mac_prefix,
    performanceProfile: _state => _state.computeClusterDetails?.performance_profile,
    computeCustomParams: _state => _state.computeClusterDetails?.options?.custom_params || [],
    migrationNetwork: _state => _state.computeClusterDetails?.options?.maas?.migration_network,
  },
};

export default computeModule;
